import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { useTitle } from 'react-use';

import SubHeaderIntent from '@/components/organisms/SubHeader/SubHeaderIntent';
import SubNavIntent from '@/components/organisms/SubNav/SubNavIntent';
import PageContentWrapper from '@/components/templates/PageContentWrapper';
import { Skeleton } from '@/components/ui/skeleton';
import useBrains from '@/hooks/useBrains';
import useIntents from '@/hooks/useIntents';
import { selectBrainId, selectIntentName } from '@/redux/session/selectors';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

export default function Intents() {
  const { t } = useTranslation();
  const brainId = useSelector(selectBrainId);
  const intentName = useSelector(selectIntentName);
  const { intents, listStatus } = useIntents(brainId);
  const { brain } = useBrains(brainId);

  useTitle(t('pages.intents', { 0: brain?.name ?? '-' }));

  useSegments(PageName.INTENTS);

  if (intents?.length) {
    return <Navigate to={`${intentName ?? intents[0].intent}`} replace />;
  }

  return (
    <div className="grid h-full grid-cols-[192px_1fr] grid-rows-[48px_1fr] gap-0">
      <SubNavIntent />
      <SubHeaderIntent />
      <PageContentWrapper>
        {listStatus === 'pending' && <Skeleton className="h-12 w-full" />}
      </PageContentWrapper>
    </div>
  );
}
